import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEqual, pick } from 'lodash';

import ContentTile from 'components/atoms/layout/ContentTile';
import ContentHeader from 'components/atoms/layout/ContentHeader';
import helpers from 'helpers';
import {
    HelpBox,
    HelpIcon,
} from 'components/atoms/callout/Help';
import { HelpWrapper } from 'components/atoms/callout/CallOutWrapper';


class ChartTile extends Component {
    constructor(props) {
        super(props);
        this.state = { toggleHelp: false };
        this.toggleHelp = this.toggleHelp.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return !isEqual(nextProps.children, this.props.children) ||
            !isEqual(nextState.toggleHelp, this.state.toggleHelp);
    }

    toggleHelp() {
        this.setState({ toggleHelp: !this.state.toggleHelp });
    }

    render() {
        let helpIcon = null;
        let helpSection = null;
        if (this.props.help) {
            helpIcon = <HelpIcon className={this.state.toggleHelp ? 'icon-close-circle' : 'icon-help-circle' } onClick={this.toggleHelp.bind(this)} />;
            helpSection = <HelpBox
                onClick={this.toggleHelp.bind(this)}
                className={this.state.toggleHelp ? 'show-help' : 'hide-help'}
                style={{ border: 0 }} >
                {this.props.help} </HelpBox>;
        }

        const contentHeaderProps = pick(this.props, ['chartRef', 'hideCSVExport']);

        return (
            <ContentTile padding={helpers.contentPadding('chart-with-legend')}>
                <ContentHeader {...contentHeaderProps } type={'chart'} helpIcon={helpIcon} >
                    {this.props.title}
                    {this.props.subTitle ? <React.Fragment><br />{this.props.subTitle}</React.Fragment> : null}
                </ContentHeader>
                <HelpWrapper style={{ position: 'relative' }}>
                    {this.props.children}
                    {helpSection}
                </HelpWrapper>
            </ContentTile>
        );
    }
}

ChartTile.defaultProps = {
    subTitle: ''
};

ChartTile.propTypes = {
    chartRef: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
    subTitle: PropTypes.string,
    hideCSVExport: PropTypes.bool
};

export default ChartTile;



// WEBPACK FOOTER //
// ./src/components/molecules/charts/ChartTile.js